(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nspire-cookie-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    const mobile = matchMedia('(max-width: 768px)');
    const relevant = '#shopify-pc__banner, #shopify-pc__prefs, #ea-sticky-cart-root';
    const watched = new Set();
    let frame = 0;

    const schedule = () => {
      if (!frame) frame = window.setTimeout(update, 16);
    };

    const resizeObserver = new ResizeObserver(schedule);
    const attributeObserver = new MutationObserver(schedule);
    const watch = node => {
      if (!node || watched.has(node)) return;
      watched.add(node);
      resizeObserver.observe(node);
      attributeObserver.observe(node, {
        attributes: true, subtree: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
    };

    const setVariable = (node, name, value) => {
      if (node.style.getPropertyValue(name) !== value) node.style.setProperty(name, value);
    };

    const visible = node => {
      if (!node || !node.getClientRects().length) return false;
      const style = getComputedStyle(node);
      return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0;
    };

    const clean = node => {
      if (!node) return;
      node.removeAttribute('data-nspire-cookie-layout');
      ['--nspire-cookie-bottom', '--nspire-cookie-height', '--nspire-cookie-top']
        .forEach(name => node.style.removeProperty(name));
    };

    function update() {
      frame = 0;
      for (const node of watched) {
        if (node.isConnected) continue;
        resizeObserver.unobserve(node);
        watched.delete(node);
      }
      const banner = document.getElementById('shopify-pc__banner');
      const prefs = document.getElementById('shopify-pc__prefs');
      const stickyRoot = document.getElementById('ea-sticky-cart-root');
      const sticky = stickyRoot?.querySelector('.eascStickyAddToCartBar');
      [banner, prefs, stickyRoot, sticky].forEach(watch);

      const bannerOpen = visible(banner);
      const prefsOpen = visible(prefs);
      if (!mobile.matches || (!bannerOpen && !prefsOpen)) {
        root.removeAttribute('data-nspire-cookie-hide-sticky');
        clean(banner);
        clean(prefs);
        return;
      }

      const viewport = window.visualViewport;
      const top = viewport?.offsetTop || 0;
      const bottom = top + (viewport?.height || innerHeight);
      const safe = document.getElementById('nspire-cookie-safe-area');
      const safeStyle = safe ? getComputedStyle(safe) : null;
      const safeTop = parseFloat(safeStyle?.paddingTop) || 0;
      const safeBottom = parseFloat(safeStyle?.paddingBottom) || 0;
      const upperEdge = top + safeTop + 12;
      let lowerEdge = bottom - safeBottom - 12;
      const bar = sticky?.getBoundingClientRect();
      const barStyle = sticky ? getComputedStyle(sticky) : null;
      const ownHide = root.hasAttribute('data-nspire-cookie-hide-sticky');
      const barOpen = bar && bar.width > 0 && bar.height > 0 &&
        bar.bottom > top && bar.top < bottom && barStyle.display !== 'none' &&
        (barStyle.visibility !== 'hidden' || ownHide);

      if (bannerOpen) {
        banner.setAttribute('data-nspire-cookie-layout', '');
        const actions = banner.querySelector('.shopify-pc__banner__btns');
        const candidateEdge = barOpen ? Math.min(lowerEdge, bar.top - 12) : lowerEdge;
        const minimumSpace = (actions?.scrollHeight || 96) + 122;
        const fallback = candidateEdge - upperEdge < minimumSpace;
        root.toggleAttribute('data-nspire-cookie-hide-sticky', prefsOpen || fallback);
        if (!fallback && !prefsOpen) lowerEdge = candidateEdge;
        setVariable(banner, '--nspire-cookie-bottom', Math.ceil(innerHeight - lowerEdge) + 'px');
        setVariable(banner, '--nspire-cookie-height', Math.max(0, Math.floor(lowerEdge - upperEdge)) + 'px');
      } else {
        clean(banner);
        root.toggleAttribute('data-nspire-cookie-hide-sticky', prefsOpen);
      }

      if (prefsOpen) {
        prefs.setAttribute('data-nspire-cookie-layout', '');
        setVariable(prefs, '--nspire-cookie-top', Math.ceil(upperEdge) + 'px');
        setVariable(prefs, '--nspire-cookie-height', Math.max(0, Math.floor(bottom - safeBottom - 12 - upperEdge)) + 'px');
      } else clean(prefs);
    }

    new MutationObserver(records => {
      if (records.some(record => record.target instanceof Element &&
        (record.target.closest(relevant) || [...record.addedNodes, ...record.removedNodes]
          .some(node => node instanceof Element && (node.matches(relevant) || node.querySelector(relevant)))))) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    mobile.addEventListener('change', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
    document.addEventListener('visitorConsentCollected', schedule);
    document.fonts?.ready.then(schedule);
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nspire-cro-cart-presentation"] && !Shopify.designMode) return;
  try {
    (() => {
  const template = document.getElementById('nspire-cro-cart-payments');
  if (!template) return;
  const desired = Array.from(template.content.querySelectorAll('img'));
  const main = document.getElementById('MainContent');
  const paymentClasses = ['ideal', 'klarna', 'visa', 'mastercard', 'amex', 'bancontact'];
  const orderProductPayments = () => {
    if (!main) return;
    main.querySelectorAll('.sternify-payment-icons').forEach(list => {
      const ordered = paymentClasses.map(name => list.querySelector('.sternify-payment-icon-' + name));
      if (ordered.some(img => !img) || list.children.length !== ordered.length) return;
      if (ordered.some((img, index) => list.children[index] !== img)) list.replaceChildren(...ordered);
    });
  };
  orderProductPayments();
  if (main) new MutationObserver(orderProductPayments).observe(main, {childList: true, subtree: true});
  const apply = root => {
    root.querySelectorAll('.sd-pay').forEach(list => {
      const current = Array.from(list.querySelectorAll('img'));
      if (current.length !== desired.length || current.some((img, i) => img.getAttribute('src') !== desired[i].getAttribute('src') || img.alt !== desired[i].alt)) {
        list.replaceChildren(template.content.cloneNode(true));
      }
    });
    if (template.dataset.locale === 'nl') {
      root.querySelectorAll('.sd-freeship__text, .sd-freeship__milestone-label').forEach(element => {
        const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (node.nodeValue.includes('Gratis')) node.nodeValue = node.nodeValue.replace(/\bGratis\b/g, 'gratis');
        }
      });
    }
  };
  const attach = () => {
    const root = document.getElementById('sternify-cart-root');
    if (!root) return false;
    apply(root);
    new MutationObserver(() => apply(root)).observe(root, {childList: true, subtree: true, characterData: true});
    return true;
  };
  if (!attach()) {
    const waiting = new MutationObserver(() => {
      if (attach()) waiting.disconnect();
    });
    waiting.observe(document.body, {childList: true, subtree: true});
  }
})();
  } catch(e) { console.error(e); }
})();

})();
